module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct-top",
    attrs: {
      "id": "pro"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct1"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Prologue: Out of Print and Scared to Death")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("K"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("URT")]), _vm._v(" V"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ONNEGUT PLANNED")]), _vm._v(" to give this new teaching job at the University of Iowa his best shot. As he zoomed across the Midwest in early September 1965 in his son’s new Volkswagen Beetle—his six-foot-three frame pressing his head against the roof liner—it was as if failure were clattering behind him like tin cans tied to the bumper. The ashtray was stuffed with the crushed butts of Pall Mall cigarettes and the windshield was tawny with nicotine from his chain-smoking. He had a lot to think about, and the twelve-hundred-mile cross-country drive between his home on Cape Cod and Iowa City, Iowa, gave him all the time he needed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was bored by his twenty-year marriage to his first love, the former Jane Cox, whom he’d married barely five months after his release from a prisoner-of-war camp at the end of World War II. This past summer, he had been trying to start an affair with a woman in New York twenty years his junior who, in turn, was waiting for the writer William Price Fox to divorce his wife so they could marry. If this writer-in-residence job in the respected Iowa Writers’ Workshop didn’t suit him, he was going to leave it and compensate himself for his trouble by coming on strong with Sarah."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#pro_fn1",
      "id": "pro-fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" On the other hand, he would remind her that he was an old boozehound, on the hunt for affection, and she was just a girl, and he was old enough to be her father. She needed him like a case of shingles."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#pro_fn2",
      "id": "pro-fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He did have a daughter almost her age, and five other children besides—three of his own with Jane and three from his sister and brother-in-law, who were dead. There was only enough money for him to come to Iowa City alone. He had not wanted to go, but everyone else seemed to think it was a good idea."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#pro_fn3",
      "id": "pro-fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" His buddy from the Cornell University "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Daily Sun")]), _vm._v(" campus newspaper, Miller Harris, had written him when he heard about the invitation, “For Christ’s sake go, knowing that your classes will be peopled exclusively by meatheads. Some of them will be pretty girls, young and fresh looking and pretty, and will fall in love with you. But meatheads still.… Wothehell—you might get some funny material out of their bad papers.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#pro_fn4",
      "id": "pro-fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Besides, as usual, he needed the money, especially since he had three children in college. So he had replied to the letter from John C. Gerber, the chair of Iowa’s Department of English, saying he was humbled by the invitation and accepted."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#pro_fn5",
      "id": "pro-fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was certain he needed the change of scene."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#pro_fn6",
      "id": "pro-fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" His temper was getting the better of him lately, rubbed raw by too much drinking and fears of being a permanent loser. About a month before he left for Iowa, his eldest daughter, fifteen-year-old Edie, had played a gypsy in a children’s production of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Treasure Island")]), _vm._v(" at the Cape Cod Playhouse. While she was signing autographs—including one for a star-struck seven-year-old Caroline Kennedy—some smart aleck standing beside him made a vulgar crack about her. He invited the guy out into the parking lot to say it again, and knocked him down between two cars. His opponent, dazed but still game, got to his feet, made another crack, and Vonnegut socked him again."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#pro_fn7",
      "id": "pro-fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Things like that got around fast on Cape Cod.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maybe it was only the remark that got to him, but he also hated the implication that he was a nobody. Obviously, the guy had no idea who he was—including that he was Edie’s father. His neighbors hadn’t read his novels, didn’t care much about books, so he felt like he had no status at all."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#pro_fn8",
      "id": "pro-fn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Not that the English Department in Iowa knew much about him, either. Actually, he knew more about their creative writing program than they knew about his work. An article about it had appeared in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Look")]), _vm._v(" magazine just a few weeks before Dr. Gerber’s invitation had arrived."), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#pro_fn9",
      "id": "pro-fn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" But he knew for a fact that the program’s director, Paul Engle, “didn’t know me, and I don’t think he had ever heard of me. He didn’t read that kind of crap. But somebody out here did, and assured him that I was indeed a writer, but dead broke with a lot of kids, and completely out of print and scared to death.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#pro_fn10",
      "id": "pro-fn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" When the poet Robert Lowell backed out at the last minute, Engle had rescued him with a steady job.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The truth was, despite his four published novels and scads of short stories in magazines found in doctors’ waiting rooms, Kurt Vonnegut’s writing career had been a nonstarter for years. In college, he’d written satirical columns, news, and opinion pieces for the Cornell newspaper, but he dropped out after two years in 1943 because of bad grades and enlisted as a private in the army. After the war, he attended the University of Chicago on the GI Bill to earn a degree in anthropology but never completed his thesis. Now, in his forties, the only academic credential he had was a diploma from Shortridge High School in Indianapolis. Packed away in the Volkswagen, he had the notes for another thesis for Chicago—a casserole of ideas that conflated fiction and anthropology—which he dreamed he might be able to finish in Iowa City in maybe a month or so. He also wanted to work on a partially written screenplay for his most recent novel, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("God Bless You, Mr. Rosewater")]), _vm._v(". Then there were the drafts of a wartime novel about his surviving the bombing of Dresden, a project he had been taking unsuccessful runs at ever since he got out of the service. Whether he could find time to work on all three would depend on his teaching schedule not being “murderously heavy.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#pro_fn11",
      "id": "pro-fn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ten miles outside of Iowa City, the Volkswagen began to thump and sway. He pulled off to the gravelly shoulder and got out, “surrounded by millions and millions of acres of topsoil” like the farmland outside Indianapolis, “as flat as pool tables and as rich as chocolate cake.”"), _c('span', {
    staticClass: "epub-sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#pro_fn12",
      "id": "pro-fn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" A tire had blown. It was quiet, except for the grasshoppers and cicadas hissing drily in the heat, and he looked around, weighing his choices.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-caced76c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 69
// module chunks = 0